module.exports = __webpack_public_path__ + "img/areaRedOrder.3c6cee1d.png";